
import TheHeader from '@components/TheHeader'

export default {
  name: 'LayoutDefault',

  components: {
    TheHeader,
  },
}
